(function () {
  var dataEl = document.getElementById('rotating-search-placeholder-data');
  if (!dataEl) return;

  var config;
  try {
    config = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var phrases = (config.phrases || []).filter(function (p) {
    return p && p.trim().length;
  });
  if (!phrases.length) return;

  var holdTime = config.speed || 3000;
  var typeSpeed = 45;
  var eraseSpeed = 25;
  var pauseAfterErase = 300;

  function getInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('input[type="search"]'));
  }

  function getLabelFor(input) {
    if (input.labels && input.labels.length) return input.labels[0];
    if (input.id) return document.querySelector('label[for="' + input.id + '"]');
    return null;
  }

  function setPlaceholder(text) {
    getInputs().forEach(function (input) {
      input.setAttribute('placeholder', text);
      var label = getLabelFor(input);
      if (label) label.textContent = text;
    });
  }

  function run(phraseIndex, charIndex, isDeleting) {
    var phrase = phrases[phraseIndex % phrases.length];
    var text = isDeleting ? phrase.slice(0, charIndex - 1) : phrase.slice(0, charIndex + 1);
    setPlaceholder(text);

    if (!isDeleting && text.length === phrase.length) {
      setTimeout(function () {
        run(phraseIndex, text.length, true);
      }, holdTime);
      return;
    }

    if (isDeleting && text.length === 0) {
      setTimeout(function () {
        run(phraseIndex + 1, 0, false);
      }, pauseAfterErase);
      return;
    }

    setTimeout(function () {
      run(phraseIndex, text.length, isDeleting);
    }, isDeleting ? eraseSpeed : typeSpeed);
  }

  function start() {
    run(0, 0, false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();